export default __webpack_public_path__ + "static/media/f1.cad4a14d.png";